import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./login";
import userDashboardReducer from "./userDashboard";
import agentSignupReducer from "./signup";
import agentDashboardReducer from "./agentDashboard";
import languageReducer from "./language";

export const store = configureStore({
  reducer: {
    loginUserData: loginReducer,
    userDashboardData: userDashboardReducer,
    registerAgentData: agentSignupReducer,
    agentDashboardData: agentDashboardReducer,
    languageData: languageReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});
